import * as React from 'react';
import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { updateGridBounds } from '../../store/mutators/updateGridBounds';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';

export interface WeekViewResizeHooksProps {
    store: CalendarSurfaceStore;
}

export default function useWeekViewResizeBehaviorHooks(props: WeekViewResizeHooksProps) {
    let parentElementRef = null as React.MutableRefObject<HTMLElement>;

    const onResize = React.useCallback(() => {
        parentElementRef?.current && updateGridBounds(props.store);
    }, [props.store?.calendarDayListBounds]);

    useWindowEvent('resize', onResize);

    return React.useCallback(
        (ref: React.MutableRefObject<HTMLElement>) => {
            parentElementRef = ref;
            onResize();

            return {
                children: null,
                handlers: {},
            };
        },
        [onResize]
    );
}
